<template>
  <div class="process-accordion">
    <div
      v-for="(item, index) in items"
      :key="`process-accordion-item-${index}`"
      :class="{
        'is-opened': currentId === index,
      }"
      class="process-accordion__item"
    >
      <button class="process-accordion__toggler" @click.prevent="() => toggle(item, index)">
        <span class="process-accordion__toggler-number">
          {{ index + 1 }}
        </span>
        <h4 class="process-accordion__toggler-text title is-3">
          {{ item.title }}
        </h4>
        <span class="process-accordion__toggler-icon">
          <pt-icon-chevron-down />
        </span>
      </button>
      <transition name="process-accordion__content" @before-enter="beforeEnter" @enter="enter" @before-leave="beforeLeave" @leave="leave">
        <div v-if="index === currentId" class="process-accordion__content">
          <div>
            <bard :as-content="true" :content="item.description" :primary-links="true" />
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import PtIconChevronDown from '~/components/global/icons/PtIconChevronDown.vue';
import Bard from '~/components/content/Bard.vue';

defineProps({
  items: {
    type: Array as () => Array<{ title: string; description: string }>,
    required: true,
  },
});

const currentId = ref(null);

const toggle = (item, index) => {
  currentId.value = currentId.value === index ? null : index;
};

const beforeEnter = (el) => {
  el.style.height = '0';
  el.style.opacity = '0';
};

const enter = (el) => {
  el.style.height = el.scrollHeight + 'px';
  el.style.opacity = '1';
};

const beforeLeave = (el) => {
  el.style.height = el.scrollHeight + 'px';
  el.style.opacity = '1';
};

const leave = (el) => {
  el.style.height = '0';
  el.style.opacity = '0';
};
</script>
